import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PermisosComponent } from './permisos/permisos.component';



const routes: Routes = [
    {
    path: "",
    children: [
      {
        path: "permisos",
        component: PermisosComponent
      }
    ]
}
]

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class SeguridadRoutingModule {}